import { isValid, isDate } from 'date-fns';

import { AbstractControl, ValidationErrors } from '@angular/forms';

export class ApValidDateValidator {
    /**
     * Validate if value in control is in list of options
     */
    public static validate(control: AbstractControl): ValidationErrors {
        if (!control.value) {
            return null;
        }

        if (!ApValidDateValidator.isValid(control.value)) {
            return { validDate: true };
        }

        return null;
    }

    /**
     * Check if passed date is valid
     */
    public static isValid(dateValue: Date): boolean {
        return isDate(dateValue) && isValid(dateValue);
    }
}
